import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, Sun, Moon, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isDark, setIsDark] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={() => scrollToSection('home')}>
            <img 
              src="/images/alpen-pro-logo-new.png" 
              alt="Alpen Pro Suisse" 
              className="h-16 w-auto md:h-20 lg:h-24"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            <button 
              onClick={() => scrollToSection('vorteile')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              Vorteile
            </button>
            <button 
              onClick={() => scrollToSection('funktioniert')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              Wie es funktioniert
            </button>
            <button 
              onClick={() => scrollToSection('referenzen')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              Referenzen
            </button>
            <button 
              onClick={() => scrollToSection('preise')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              Preise
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              FAQ
            </button>
          </nav>

          {/* Right Side Buttons */}
          <div className="hidden lg:flex items-center gap-4">
            <a 
              href="tel:+41762652627"
              className="flex items-center gap-2 text-gray-700 hover:text-cyan-600 transition-colors font-semibold"
            >
              <Phone className="w-5 h-5" />
              <span>+41 76 265 26 27</span>
            </a>
            <button
              onClick={() => setIsDark(!isDark)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </button>
            <Button 
              onClick={() => scrollToSection('kontakt')}
              className="bg-gradient-to-r from-cyan-600 to-purple-600 hover:from-cyan-700 hover:to-purple-700 text-white px-6 shadow-lg"
            >
              📞 Offerte anfordern
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <nav className="flex flex-col gap-4">
              <a 
                href="tel:+41762652627"
                className="flex items-center gap-2 text-gray-700 font-semibold p-3 bg-cyan-50 rounded-lg"
              >
                <Phone className="w-5 h-5 text-cyan-600" />
                <span>+41 76 265 26 27</span>
              </a>
              <button 
                onClick={() => scrollToSection('vorteile')}
                className="text-gray-600 hover:text-gray-900 font-medium text-left"
              >
                Vorteile
              </button>
              <button 
                onClick={() => scrollToSection('funktioniert')}
                className="text-gray-600 hover:text-gray-900 font-medium text-left"
              >
                Wie es funktioniert
              </button>
              <button 
                onClick={() => scrollToSection('referenzen')}
                className="text-gray-600 hover:text-gray-900 font-medium text-left"
              >
                Referenzen
              </button>
              <button 
                onClick={() => scrollToSection('preise')}
                className="text-gray-600 hover:text-gray-900 font-medium text-left"
              >
                Preise
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-gray-600 hover:text-gray-900 font-medium text-left"
              >
                FAQ
              </button>
              <Button 
                onClick={() => scrollToSection('kontakt')}
                className="bg-gradient-to-r from-cyan-600 to-purple-600 hover:from-cyan-700 hover:to-purple-700 text-white w-full mt-2"
              >
                📞 Offerte anfordern
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
